export default {
    year: [
        { required: true, message: '请选择年份', trigger: 'change' }
    ],
    category3Code: [
        { required: true, message: '请选择Category3', trigger: 'change' }
    ],
    rmcProteinAslId: [
        { required: true, message: '请选择Protein ASL', trigger: 'change' }
    ],
    auditType: [
        { required: true, message: '请选择审核类型', trigger: 'change' }
    ],
    aslAuditDate: [
        { required: true, message: '请选择审核时间', trigger: 'change' }
    ],
    gmp: [
        { required: true, message: '请选择gmp', trigger: 'change' }
    ],
    animalWalfare: [
        { required: true, message: '请选择AnimalWalfare', trigger: 'change' }
    ],
    
}